import Vue from 'vue';
import Router from 'vue-router';
import appPromoRequestsRoutes from './portals/PromoRequests/routes';
import appGrabberRoutes from './portals/Grabber/routes';
import appRoutes from './portals/Application/routes';
import artRoutes from './portals/Artist/routes';
import adminRoutes from './portals/Administration/routes';
import supplierRoutes from './portals/Supplier/routes';
import authRoutes from './portals/Authorization/routes';
import updateRoutes from './portals/UpdateApp/routes';
import promoStandardsRoutes from './portals/PromoStandards/routes';
import { checkVersion } from './utils/checkVersion';
import { hasSubscriptionAccess } from './portals/utils';
import { needToCheckVersion } from './router.rules';

const logRouterError = (e) => {
  if (/NavigationDuplicated/.test(`${e.stack}`) || /Redirected/.test(`${e.stack}`)) {
    console.log('%c NavigationDuplicated or Redirected...', 'color: red');
  } else {
    throw e;
  }
};

const { replace: routerReplace, push: routerPush } = Router.prototype;
Router.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(logRouterError);
};
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(logRouterError);
};

Vue.use(Router);
const allRoutes = [].concat(
  appPromoRequestsRoutes,
  appGrabberRoutes,
  appRoutes,
  artRoutes,
  adminRoutes,
  supplierRoutes,
  promoStandardsRoutes,
  authRoutes,
  updateRoutes
);
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: allRoutes
});
router.beforeEach((to, from, next) => {
  hasSubscriptionAccess(to, from, next);
});
router.afterEach((route) => {
  route.matched.forEach((routeRecord) => {
    if (routeRecord.meta && routeRecord.meta.storeLastTab) {
      localStorage.setItem(routeRecord.meta.storeLastTab, route.fullPath);
    }
  });
  const _needToCheckVersion = !needToCheckVersion.find((e) => location.pathname.match(e));
  const hasNoRedirect = !route.fullPath.includes('redirect');
  if (_needToCheckVersion && hasNoRedirect) {
    return checkVersion();
  }
});
export default router;
